import { useEffect, useState } from 'react';
import { UPGRADE_POINT_LOCATIONS } from '../../_core/common/constants/PurchaseMotionLocations';
import { purchaseMotionButtonPropsInterface, purchaseMotionButtons } from '../../_core/common/constants/purchaseMotions';
import { MergedPurchaseMotionProps } from '../../_core/purchaseMotions/PurchaseMotionPropsInterface';
import { mapPurchaseMotionApiName } from '../../ums/utils';
import { isUndefined, omit } from '../../utils';
import { getCanViewNewSeats } from '../common/eligibility/getCanViewNewSeats';
import { jsx as _jsx } from "react/jsx-runtime";
const PurchaseMotionButton = props => {
  var _props$purchaseMotion;
  const {
    upgradeData,
    trackingSource,
    level,
    passthroughProps = {},
    overrides = {},
    location,
    'data-selenium-id': dataSeleniumId
  } = props;
  const purchaseMotion = (_props$purchaseMotion = props.purchaseMotion) !== null && _props$purchaseMotion !== void 0 ? _props$purchaseMotion : props.purchaseMotions[props.level - 1];
  const isUpgradePoint = location && UPGRADE_POINT_LOCATIONS.includes(location);
  const mappedButtonPassthroughProps = passthroughProps[purchaseMotion] || {};
  const mappedButtonPropsInterface = purchaseMotionButtonPropsInterface[purchaseMotion];
  const MappedButtonComponent = overrides[purchaseMotion] || purchaseMotionButtons[purchaseMotion];
  const [canViewNewSeats, setCanViewNewSeats] = useState(undefined);
  useEffect(() => {
    getCanViewNewSeats().then(res => {
      setCanViewNewSeats(res);
      upgradeData.apiName = mapPurchaseMotionApiName(res, upgradeData.upgradeProduct, 'purchaseMotion', upgradeData.apiName);
    }).catch(() => {
      setCanViewNewSeats(false);
    });
  }, [props, upgradeData]);
  if (isUndefined(MappedButtonComponent) || isUndefined(mappedButtonPropsInterface)) {
    return null;
  }
  const propsToKeep = [...Object.keys(mappedButtonPropsInterface), 'upgradeData', 'use', 'block', 'size', 'children', 'className', 'disabled'];

  // Exclude the PurchaseMotionButton parent props and non-related props from
  // other types of purchase motions
  const propsToOmit = ['purchaseMotion', 'purchaseMotions', 'purchaseMotionLocation', 'level', 'overrides', 'passthroughProps', 'isUpgradePoint', 'data-selenium-id', ...Object.keys(omit(MergedPurchaseMotionProps, propsToKeep))];
  const propsToPass = omit(props, propsToOmit);
  // propsToPass needs to get the result from getCanViewNewSeats
  propsToPass.canViewNewSeats = canViewNewSeats;
  return /*#__PURE__*/_jsx(MappedButtonComponent, Object.assign({
    "data-selenium-id": dataSeleniumId || `${trackingSource}-${props.upgradeData.apiName}-${purchaseMotion}-button`,
    truncate: true,
    isUpgradePoint: isUpgradePoint,
    level: level,
    canViewNewSeats: canViewNewSeats
  }, mappedButtonPassthroughProps, propsToPass));
};
export default PurchaseMotionButton;